import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import classnames from "classnames";
import { Box } from "@material-ui/core";

// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";

// pages
import VerticalizationPage from "../Verticalization/Verticalization";
import WebsiteAnalyserPage from "../../Pages/WebsiteAnalyser";
import MiscellaneousPage from "../../Pages/Miscellaneous";
import ApprovedDomainsPage from "../../Pages/ApprovedDomains";
import AdRenderersPage from "../../Pages/AdRenderers";
import KeywordCheckerPage from "../../Pages/KeywordChecker";

import Experiments from "../../Pages/Experiments/Experiments";
import TextMergerPage from "../../Pages/TextMergerPage/Textmergerpage";
import UrlOpenerPage from "../../Pages/UrlOpenerPage/urlopenerpage";
import SellersJsonExporterPage from "../../Pages/SellersJsonPage/sellersjsonpage";
import BidRequestPage from "../../Pages/BidRequestPage/bidrequestpage";
import ApprovedBundlesTable from "../../Pages/ApprovedBundles/approvedbundles";
import SqtaPage from "../../Pages/Sqta/sqta";

// context
import { useLayoutState } from "../../Context/LayoutContext";
import CTVAnalyser from "../CTVAnalyser/CTVAnalyser";
import AppAnalyser20Page from "../AppAnalyser20/AppAnalyserBeta";

function Layout(props) {
  var classes = useStyles();
  var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
      <>
        <Header history={props.history} />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          <Switch>
            <Route path="/app/appanalyser" component={VerticalizationPage} />
            <Route path="/app/appanalyser2" component={AppAnalyser20Page} />
            <Route path="/app/websiteanalyser" component={WebsiteAnalyserPage} />
            <Route path="/app/adrenderers" component={AdRenderersPage} />
            <Route path="/app/miscellaneous" component={MiscellaneousPage} />
            <Route path="/app/keywordchecker" component={KeywordCheckerPage} />
            <Route path="/app/ctvanalyser" component={CTVAnalyser} />
            <Route path="/app/textmerger" component={TextMergerPage} />
            <Route path="/app/urlopener" component={UrlOpenerPage} />
            <Route path="/app/sellersjsonexporter" component={SellersJsonExporterPage} />
            <Route path="/app/bidrequestsanalyser" component={BidRequestPage} />
            <Route path="/app/experiments" component={Experiments} />
            <Route exact path="/app/sellerjsonvalidator" render={() => <Redirect to="/app/sellersjsonexporter" />} />
            <Route path="/app/approved" component={ApprovedDomainsPage} />
            <Route path="/app/approvedbundles" component={ApprovedBundlesTable} />
            <Route path="/app/sqta" component={SqtaPage} />
          </Switch>
          <Box mt={5} width="100%" display="flex" alignItems="center" justifyContent="space-between">
            <div>
              <h6>Copyright Damian Chymkowski 2023-2025</h6>
            </div>
          </Box>
        </div>
      </>
    </div>
  );
}

export default withRouter(Layout);
